import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/pwa";

// Silence benign ResizeObserver warning surfaced by Radix Select in some browsers.
// It is a no-op notification, not a real error, and pollutes the dev overlay.
if (typeof window !== "undefined") {
  const RO_MSG = "ResizeObserver loop";
  window.addEventListener("error", (e) => {
    if (e?.message && e.message.includes(RO_MSG)) {
      e.stopImmediatePropagation();
    }
  });
  window.addEventListener("unhandledrejection", (e) => {
    const msg = e?.reason?.message || "";
    if (msg.includes(RO_MSG)) e.stopImmediatePropagation();
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

registerServiceWorker();
